/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S3_Li6Inputs */

const tr_kvkkbasvuru_s3_li6 = /** @type {(inputs: Kvkkbasvuru_S3_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talebinize ilişkin bilgi ve belgeler`)
};

const en_kvkkbasvuru_s3_li6 = /** @type {(inputs: Kvkkbasvuru_S3_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information and documents relating to your request`)
};

const de_kvkkbasvuru_s3_li6 = /** @type {(inputs: Kvkkbasvuru_S3_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informationen und Unterlagen zu Ihrem Anliegen`)
};

const ru_kvkkbasvuru_s3_li6 = /** @type {(inputs: Kvkkbasvuru_S3_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация и документы, относящиеся к вашему требованию`)
};

/**
* | output |
* | --- |
* | "Information and documents relating to your request" |
*
* @param {Kvkkbasvuru_S3_Li6Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s3_li6 = /** @type {((inputs?: Kvkkbasvuru_S3_Li6Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S3_Li6Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s3_li6(inputs)
	if (locale === "de") return de_kvkkbasvuru_s3_li6(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s3_li6(inputs)
	return tr_kvkkbasvuru_s3_li6(inputs)
});